import React from 'react';
import { WorkbenchProvider, useWorkbench } from './WorkbenchContext';
import RequirementsGathering from './components/RequirementsGathering';
import PackageDesign from './components/PackageDesign';
import ReferenceLibrary from './components/ReferenceLibrary';
import MyCases from './components/MyCases';
import WorkbenchAwareAssistant from './WorkbenchAwareAssistant';

function WorkbenchContent() {
  const { activeTab, setActiveTab, activeCase } = useWorkbench();

  const tabs = [
    { id: 'my-cases', label: 'My Cases', icon: '\u2696' },
    { id: 'reference-library', label: 'Reference Library', icon: '\uD83D\uDCDA' },
    { id: 'requirements', label: 'Document Analysis', icon: '\uD83D\uDCCB' },
    { id: 'package-design', label: 'Template Creation', icon: '\u2696\uFE0F' }
  ];

  return (
    <div className="h-full flex flex-col bg-galaxy-950">
      {/* Bridge workbench context to AI Assistant */}
      <WorkbenchAwareAssistant />

      {/* Tab Bar */}
      <div className="bg-galaxy-900/50 border-b border-galaxy-800/50 px-6 py-3">
        <div className="flex gap-4">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all ${
                activeTab === tab.id
                  ? 'bg-galaxy-600 text-white'
                  : 'text-galaxy-300 hover:bg-galaxy-800/50 hover:text-white'
              }`}
            >
              <span>{tab.icon}</span>
              <span className="font-medium">{tab.label}</span>
              {/* Show active case indicator on relevant tabs */}
              {(tab.id === 'requirements' || tab.id === 'reference-library' || tab.id === 'package-design') && activeCase && (
                <span className="ml-1 w-2 h-2 bg-green-500 rounded-full" title={`Active: ${activeCase.name}`} />
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="flex-1 overflow-auto">
        {activeTab === 'my-cases' && <MyCases />}
        {activeTab === 'reference-library' && <ReferenceLibrary />}
        {activeTab === 'requirements' && <RequirementsGathering />}
        {activeTab === 'package-design' && <PackageDesign />}
      </div>
    </div>
  );
}

function Workbench() {
  return (
    <WorkbenchProvider>
      <WorkbenchContent />
    </WorkbenchProvider>
  );
}

export default Workbench;
